import routes from '../router/routes';

export function isProductDetailsPage(pathname: string): boolean {
  return [routes.PARKING_PDP, routes.LOUNGES_PDP].includes(pathname);
}

export function isTravellerInformationPage(pathname: string): boolean {
  return [routes.PARKING_TIP, routes.LOUNGES_TIP].includes(pathname);
}

export function isPaymentInformationPage(pathname: string): boolean {
  return [routes.PARKING_PIP, routes.LOUNGES_PIP].includes(pathname);
}

export function isBookingConfirmationPage(pathname: string): boolean {
  return [routes.PARKING_BCP, routes.LOUNGES_BCP].includes(pathname);
}

export function isSearchInputPage(pathname: string): boolean {
  return [routes.PARKING_SEARCH, routes.LOUNGES_SEARCH].includes(pathname);
}

export function isSearchResultsPage(pathname: string): boolean {
  return [routes.PARKING_SEARCH_RESULTS, routes.LOUNGES_SEARCH_RESULTS].includes(pathname);
}
